function getOnboardingStepName(step: number): string {
    const stepNames: { [key: number]: string } = {
        0: 'Welcome to Onboarding',
        1: 'Industry Selection',
        2: 'Position Selection',
        3: 'Question Selection',
        4: 'Billing Information',
    };

    return stepNames[step] || 'Unknown Step';
}

export default getOnboardingStepName;